import ParentProgressReportV2 from "./ParentProgressReportV2";

export default ParentProgressReportV2;
